import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { Button, Grid } from "@material-ui/core";
import loginBackground from "assets/img/desktop.jpg";
import tabletLogin from "assets/img/tablet.png";
import GoogleIcon from "assets/img/google-logo.png";
import { saveAuthData, saveUserData } from "store/reducers/login/LoginSlice";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import Cookies from "js-cookie";
import Footer from "components/UpdateUi/Footer/Footer";
import btoa from "btoa";
import axios from "axios";
import uuid from "react-uuid";
import CustomeTextField from "components/UpdateUi/CustomeTextField.js";
import brandTheme from "brandTheme/Theme";
import ToastModal from '../components/ToastModal'
import CircularProgresss from "views/components/CircularProgress/CircularProgress";
const style = () => ({
  textField: {
    display: "block",
    width: "100%",
  },
  backgroundImage: {
    backgroundImage: `url(${loginBackground})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 100%",
    height: "91vh",
    width: "100%",
    "@media (max-width:1023px)": {
      backgroundImage: `url(${tabletLogin})`,
    },
    "@media (max-width:600px)": {
      backgroundImage: "inherit",
    },
  },
  wrapLogin100: {
    textAlign: "center",
    marginTop: 10,
    marginLeft: "4%",
    marginRight: "4%",
    background: brandTheme.white,
    padding: "3%",
    borderRadius: "10px",
    width: "25%",
    "@media (max-width:1023px)": {
      width: "35%",
      marginLeft: "2%",
    },
    "@media (max-width:600px)": {
      width: "100%",
    },
  },
  submitButton: {
    width: "100%",
    fontWeight: "bold",
    backgroundColor: brandTheme.buttonColor,
    color: brandTheme.white,
    padding: "6px 0px",
    textTransform: "capitalize",
    fontSize: "14px",
    "&:hover": {
      backgroundColor: brandTheme.black,
    },
  },
  mediaButtonLoginInner: {
    width: "100%",
    textTransform: "capitalize",
    fontSize: "14px",
    fontWeight: "bold",
    padding: "6px 0px",
    backgroundColor: brandTheme.white,
    border: `1px solid ${brandTheme.buttonColor}`,
    color: brandTheme.buttonColor,
    "&:hover": {
      width: "92%",
      backgroundColor: brandTheme.footerBackGroundColor,
      transform: "scale(1.1)",
      transition: "0.5s",
    },
    "& img": {
      width: 17,
      transform: "scale(1.1)",
      marginRight: "30px",
    },
    "& span": {
      transform: "scale(1.3)",
      fontSize: "12px",
      padding: "1px",
    },
  },
  welcomeText: {
    width: "18%",
    paddingLeft: "8%",
    textAlign: "center",
    fontSize: "14px",
    "& h2": {
      fontFamily: "cursive",
      fontStyle: "italic",
    },
    "@media (max-width:1023px)": {
      width: "23%",
      paddingLeft: "4%",
    },
    "@media (max-width:600px)": {
      display: "none",
    },
    "& span": {
      fontWeight: 700,
      fontSize: "40px",
      color: "#f4be23",
      "@media (max-width:1023px)": {
        fontSize: "28px",
      },
    },
  },
  mainContainer: {
    display: "flex",
    gap: "2%",
    alignItems: "center",
    height: "100%",
  },
  loginPage: {
    height: "100vh",
  },
  forgetTextClass: {
    cursor: "pointer",
  },
  imageHeight: {
    minHeight: "60px",
  },
  textStyle: {
    color: "#55D24B",
    fontSize: "30px",
    fontWeight: "bold",
  },

  lineStyle: {
    borderTop: "1px solid #ccc",
    margin: "20px 0",
  },

  bottomTextStyle: {
    fontWeight: "bold",
  },
});

const LoginPage = (props) => {
  const [userName, setUserName] = useState("");
  const [userNameState, setUserNameState] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordState, setPasswordState] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordState, setNewPasswordState] = useState(false);
  const [googleLoginFlags, setGoogleLoginFlags] = useState(false);
  const [forgetPasswordFlags, setForgetPasswordFlags] = useState(false);
  const [callInProgress, setCallInProgress] = useState(false);
  const [showUserNameField, setShowUserNameField] = useState(false);
  const [showOtpFields, setShowOtpFields] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [OtpField, setOtpField] = useState("");
  const [OtpFieldState, setOtpFieldState] = useState("");
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('')
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    getFeatureFlag();
  }, []);
  const [logo, setLogo] = useState("");
  useEffect(() => {
    if (!logo) {
      GetLogoLink();
    }
  }, [logo]);
    const GetLogoLink = () => {
    apiHandler({
      url: endpoint.LOGO_URL,
      method: "GET",
    })
      .then((result) => {
       if (result?.data?.logo) {
        setLogo(result?.data?.logo);
       }
      })
      .catch((error) => {
        console.error("Logo API Error:", error);
      })
      .finally(() => {
       console.error("Logo API Exit:");
      });
  };
  const getFeatureFlag = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.FEATURE_FLAG,
    });
    setCallInProgress(false);

    parseAndSetFlag(result?.data?.googleSignInFlag, setGoogleLoginFlags);
    parseAndSetFlag(result?.data?.forgetPasswordFlag, setForgetPasswordFlags);
  };

  const parseAndSetFlag = (flag, setStateFunction) => {
    const parsedFlag = typeof flag === "boolean" ? flag : flag === "true";
    setStateFunction(parsedFlag);
  };

  const handleClick = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url:
        endpoint.SOCIAL_LOGIN +
        "?redirect_uri=" +
        window.location.origin +
        "/oauth2",
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.error_description, true)
    } else {
      Cookies.set("oauth", result?.data.headers["oauth"]);
      window.location.href = result?.data.redirectUrl;
    }
  };
  const isValidated = () => {
    if (userName === "") {
      setUserNameState(true);
    } else {
      setUserNameState(false);
    }
    if (password === "") {
      setPasswordState(true);
    } else {
      setPasswordState(false);
    }
    if (userName && password) {
      return true;
    } else {
      return false;
    }
  };
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        const activeElement = document.activeElement;
        if (activeElement.id === 'lp_userName' || activeElement.id === 'Password') {
          handleLoginSubmit(e);
        }
      }
    };
    // Add event listener for keydown events
    window.addEventListener('keydown', handleKeyDown);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [userName, password]);
  const { classes } = props;
  const toastUpdate = (type, message, showToast)=> {
    setToastMessageType(type)
    setToastMessage(message)
    setToast(showToast)
  }
  const handleLoginSubmit = async (e) => {
    if (isValidated()) {
      const data = {
        grant_type: "password",
        username: userName,
        password: password,
      };
      var basicAuth = "Basic " + btoa("arg:password");
      setCallInProgress(true);
      axios({
        url: endpoint.BASE_URL_STAGING + endpoint.SIGN_IN,
        method: "post",
        headers: {
          Authorization: basicAuth,
        },
        data: data,
      })
        .then((response) => {
          setCallInProgress(false);
          if (response?.data?.error_code || response?.data.error) {
            const errorMessage= response?.data?.user_description || response?.data?.error_description
            toastUpdate("Error", errorMessage, true)
          } else {
            dispatch(
              saveAuthData({
                authToken: response?.data.access_token,
                refreshToken: response?.data.refresh_token,
                tokenTime: Date.now(),
                isAuthenticated: true,
              })
            );
            dispatch(
              saveUserData({
                role: response?.data?.role ? response?.data?.role : "",
                username: response?.data?.username ? response?.data?.username : "",
                email: response?.data?.email ? response?.data?.email : "",
                name: response?.data?.name ? response?.data?.name : "",
              })
            );
            sessionStorage.setItem("session", uuid());
            navigate("/apps/modules");
          }
        })
        .catch((response) => {
          setCallInProgress(false);
        });
    }
  };
  const callForgetPasswordApi = async () => {
    setShowUserNameField(true);
  };
  const isValidatedUserName = () => {
    if (userName === "") {
      setUserNameState(true);
    } else {
      setUserNameState(false);
    }
    if (userName) {
      return true;
    } else {
      return false;
    }
  };
  const handleContinueButton = async (e) => {
    if (isValidatedUserName()) {
      setCallInProgress(true);
      axios({
        url: endpoint.FORGET_PASSWORD,
        method: "POST",
        data: {
          username: userName,
        },
      })
        .then((response) => {
          setCallInProgress(false);
          if (response?.data?.error_code) {
            const errorMessage= response?.data?.user_description || response?.data?.error_description
            toastUpdate("Error", errorMessage, true)
          } else {
            toastUpdate("Information", response?.data?.message, true)
            setShowUserNameField(false);
            setShowOtpFields(true);
          }
        })
        .catch((response) => {
          setCallInProgress(false);
        });
    }
  };
  const isValidatedOtp = () => {
    if (newPassword === "") {
      setNewPasswordState(true);
    } else {
      setNewPasswordState(false);
    }
    if (OtpField === "") {
      setOtpFieldState(true);
    } else {
      setOtpFieldState(false);
    }
    if (newPassword && OtpField) {
      return true;
    } else {
      return false;
    }
  };
  const handelResetPassword = async () => {
    if (isValidatedOtp()) {
      setCallInProgress(true);
      axios({
        url: endpoint.RESET_PASSWORD,
        method: "POST",
        data: {
          username: userName,
          password: newPassword,
          otp: OtpField,
        },
      })
        .then((response) => {
          setCallInProgress(false);
          if (response?.data?.error_code) {
            toastUpdate("Error", response?.data?.error_description, true)
          } else {
            toastUpdate("Information", response?.data?.message, true)
            setShowOtpFields(false);
            setShowSuccessMessage(true);
          }
        })
        .catch((response) => {
          setCallInProgress(false);
        });
    }
  };
  const handleLoginPassword = () => {
    setShowOtpFields(false);
    setShowSuccessMessage(false);
    setShowUserNameField(false);
  };
  return (
    <div className={classes.loginPage}>
      <Grid justify="center">
        <Grid xs={12} sm={12} md={12} lg={12} style={{ padding: 0 }}>
          <div className={classes.backgroundImage}>
            <div className={classes.mainContainer}>
              <div className={classes.welcomeText}>
                <h2 style={{ position: "relative" }}>
                  welcome to{" "}
                  <span>
                    DIGIRINN
                    <sup
                      style={{
                        fontSize: "15px",
                        marginLeft: "4px",
                        position: "absolute",
                        top: 39,
                      }}
                    >
                      TM
                    </sup>
                  </span>
                </h2>
              </div>
              <div className={classes.wrapLogin100}>
                <form className={classes.login100Form}>
                  <div className={classes.imageHeight}>
                    {logo && (
                      <img style={{ width: "200px" }} alt="logo" src={logo} />
                    )}
                  </div>
                  {!showUserNameField &&
                    !showOtpFields &&
                    !showSuccessMessage && (
                      <>
                        <span
                          style={{
                            textAlign: "left",
                            padding: "10px 0px",
                            display: "block",
                            fontSize: "14px",
                            fontWeight: 700,
                          }}
                        >
                          Login Your Account{" "}
                        </span>

                        <div>
                          <CustomeTextField
                            label="User Name"
                            required
                            id="lp_userName"
                            value={userName}
                            setState={setUserName}
                            error={userNameState}
                          />
                          <CustomeTextField
                            label="Password"
                            required
                            id="Password"
                            type="password"
                            value={password}
                            setState={setPassword}
                            error={passwordState}
                          />
                        </div>
                        <Button
                          round={false}
                          color="info"
                          onClick={(e) => handleLoginSubmit(e)}
                          className={classes.submitButton}
                        >
                          Login
                        </Button>
                        {forgetPasswordFlags && (
                          <p>
                            <a
                              href
                              className={classes.forgetTextClass}
                              onClick={callForgetPasswordApi}
                            >
                              Forgot Password?
                            </a>
                          </p>
                        )}
                      </>
                    )}
                  {showUserNameField && (
                    <>
                      <div>
                        <CustomeTextField
                          label="User Name"
                          required
                          id="lp_userName"
                          value={userName}
                          setState={setUserName}
                          error={userNameState}
                        />
                      </div>
                      <Button
                        round={false}
                        color="info"
                        onClick={(e) => handleContinueButton(e)}
                        className={classes.submitButton}
                      >
                        Continue
                      </Button>
                    </>
                  )}
                  {showOtpFields && (
                    <>
                      <div>
                        <CustomeTextField
                          label="User Name"
                          required
                          id="lp_userName"
                          value={userName}
                          setState={setUserName}
                          error={userNameState}
                          disabled={true}
                        />
                        <CustomeTextField
                          label="New Password"
                          required
                          id="new_password"
                          type="password"
                          value={newPassword}
                          setState={setNewPassword}
                          error={newPasswordState}
                        />
                        <CustomeTextField
                          label="OTP"
                          required
                          id="otp"
                          type="otp"
                          value={OtpField}
                          setState={setOtpField}
                          error={OtpFieldState}
                        />
                      </div>
                      <Button
                        round={false}
                        color="info"
                        onClick={(e) => handelResetPassword()}
                        className={classes.submitButton}
                      >
                        Submit
                      </Button>
                    </>
                  )}
                  {showSuccessMessage && (
                    <>
                      <p className={classes.textStyle}>Success!</p>
                      <div className={classes.lineStyle}></div>
                      <p className={classes.bottomTextStyle}>
                        Password Changed Successfully!!
                      </p>
                      <Button
                        round={false}
                        color="info"
                        onClick={(e) => handleLoginPassword()}
                        className={classes.submitButton}
                      >
                        Login
                      </Button>
                    </>
                  )}
                  {googleLoginFlags && (
                    <>
                      <p>
                        -----------------------OR --------------------------
                      </p>
                      <div>
                        <Button
                          aria-label="Google Login"
                          onClick={(e) => handleClick(e)}
                          className={classes.mediaButtonLoginInner}
                        >
                          <img src={GoogleIcon} alt="Google" />
                          <span>Continue With Google</span>
                        </Button>
                      </div>
                    </>
                  )}
                </form>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
        {toast && (
              <ToastModal 
              toastMessage={toastMessage} 
              toastMessageType={toastMessageType} 
              toastUpdate={toastUpdate}
        />
        )}
      <Footer />
    </div>
  );
};

LoginPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(style)(LoginPage);
